export default "__VITE_ASSET__Lf9TeAS$__"